/**
 * Multi-select dropdown enhancements
 * - Keep dropdown open while selecting
 * - Update button text with selection count
 * - Toggle bold label class on active filters
 * - Manage clear buttons for filter fields
 * - Improve mobile UX
 */
document.addEventListener('DOMContentLoaded', function() {
    // Prevent dropdown from closing when clicking checkboxes
    document.querySelectorAll('.dropdown-menu').forEach(function(menu) {
        menu.addEventListener('click', function(e) {
            if (e.target.type === 'checkbox' || e.target.tagName === 'LABEL') {
                e.stopPropagation();
            }
        });
    });

    /**
     * Toggle the filter-label-active class on the label associated with a filter
     */
    function updateFilterIndicator(filterName, isActive) {
        // Date inputs: find label by 'for' attribute
        var label = document.querySelector('label[for="' + filterName + '"]');

        // Dropdown filters (counties, regions): find via data-filter-group
        if (!label) {
            var filterGroup = document.querySelector('[data-filter-group="' + filterName + '"]');
            if (filterGroup) {
                label = filterGroup.closest('.col-12, .col-md-6').querySelector('.form-label');
            }
        }

        // In The Game checkbox: find by id
        if (!label && filterName === 'in_game_network') {
            label = document.querySelector('label[for="in-game-network"]');
        }

        // Stay In the Game! Level select: find by id
        if (!label && filterName === 'game_level') {
            label = document.querySelector('label[for="game-level"]');
        }

        if (label) {
            label.classList.toggle('filter-label-active', isActive);
        }

        // Manage clear button for date fields
        if (filterName === 'start_date' || filterName === 'end_date') {
            updateDateClearButton(filterName, isActive);
        }

        // Manage clear button for dropdown fields
        if (filterName === 'counties' || filterName === 'regions') {
            updateDropdownClearButton(filterName, isActive);
        }

        // Manage clear button for in_game_network checkbox
        if (filterName === 'in_game_network') {
            updateCheckboxClearButton(isActive);
        }

        // Manage clear button for Stay In the Game! Level select
        if (filterName === 'game_level') {
            updateSelectClearButton(isActive);
        }
    }

    /**
     * Create or remove a clear button for the Stay In the Game! Level select
     */
    function updateSelectClearButton(isActive) {
        var label = document.querySelector('label[for="game-level"]');
        if (!label) return;

        var clearBtn = label.querySelector('.filter-clear-btn');

        if (isActive) {
            if (!clearBtn) {
                clearBtn = document.createElement('button');
                clearBtn.type = 'button';
                clearBtn.className = 'btn btn-link p-0 filter-clear-btn filter-clear-btn--inline';
                clearBtn.dataset.filter = 'game_level';
                clearBtn.innerHTML = '<i class="bi bi-x-circle text-danger" aria-hidden="true"></i><span class="visually-hidden">Clear Stay In the Game! Level filter</span>';
                label.appendChild(clearBtn);
            }
        } else {
            if (clearBtn) {
                clearBtn.remove();
            }
        }
    }

    /**
     * Create or remove a clear button for date inputs
     */
    function updateDateClearButton(filterName, isActive) {
        var label = document.querySelector('label[for="' + filterName + '"]');
        if (!label) return;

        var clearBtn = label.querySelector('.filter-clear-btn');

        if (isActive) {
            if (!clearBtn) {
                clearBtn = document.createElement('button');
                clearBtn.type = 'button';
                clearBtn.className = 'btn btn-link p-0 filter-clear-btn filter-clear-btn--inline';
                clearBtn.dataset.filter = filterName;
                clearBtn.innerHTML = '<i class="bi bi-x-circle text-danger" aria-hidden="true"></i><span class="visually-hidden">Clear ' + filterName.replace('_', ' ') + ' filter</span>';
                label.appendChild(clearBtn);
            }
        } else {
            if (clearBtn) {
                clearBtn.remove();
            }
        }
    }

    /**
     * Create or remove a clear button for dropdown filters
     */
    function updateDropdownClearButton(filterName, isActive) {
        var filterGroup = document.querySelector('[data-filter-group="' + filterName + '"]');
        if (!filterGroup) return;

        // Find the label sibling above the dropdown
        var col = filterGroup.closest('.col-12, .col-md-6');
        if (!col) return;

        var label = col.querySelector('.form-label');
        if (!label) return;

        var clearBtn = label.querySelector('.filter-clear-btn');

        if (isActive) {
            if (!clearBtn) {
                clearBtn = document.createElement('button');
                clearBtn.type = 'button';
                clearBtn.className = 'btn btn-link p-0 filter-clear-btn filter-clear-btn--inline';
                clearBtn.dataset.filter = filterName;
                clearBtn.innerHTML = '<i class="bi bi-x-circle text-danger" aria-hidden="true"></i><span class="visually-hidden">Clear ' + filterName + ' filter</span>';
                label.appendChild(clearBtn);
            }
        } else {
            if (clearBtn) {
                clearBtn.remove();
            }
        }
    }

    /**
     * Create or remove a clear button for in_game_network checkbox
     */
    function updateCheckboxClearButton(isActive) {
        var checkbox = document.getElementById('in-game-network');
        if (!checkbox) return;

        var label = document.querySelector('label[for="in-game-network"]');
        if (!label) return;

        var clearBtn = label.querySelector('.filter-clear-btn');

        if (isActive) {
            if (!clearBtn) {
                clearBtn = document.createElement('button');
                clearBtn.type = 'button';
                clearBtn.className = 'btn btn-link p-0 filter-clear-btn filter-clear-btn--inline';
                clearBtn.dataset.filter = 'in_game_network';
                clearBtn.innerHTML = '<i class="bi bi-x-circle text-danger" aria-hidden="true"></i><span class="visually-hidden">Clear In The Game Network filter</span>';
                label.appendChild(clearBtn);
            }
        } else {
            if (clearBtn) {
                clearBtn.remove();
            }
        }
    }

    // Update dropdown button text with selection count
    function updateDropdownText(dropdown) {
        var button = dropdown.querySelector('.dropdown-toggle');
        var checkboxes = dropdown.querySelectorAll('input[type="checkbox"]');
        var checked = Array.from(checkboxes).filter(function(cb) { return cb.checked; });
        var badge = button.querySelector('.options-count');
        var filterGroup = dropdown.getAttribute('data-filter-group');

        if (checked.length > 0) {
            if (badge) {
                badge.textContent = checked.length;
            } else {
                var newBadge = document.createElement('span');
                newBadge.className = 'options-count';
                newBadge.textContent = checked.length;
                button.appendChild(newBadge);
            }
        } else {
            if (badge) {
                badge.remove();
            }
        }

        // Update indicator for this filter group
        if (filterGroup) {
            updateFilterIndicator(filterGroup, checked.length > 0);
        }
    }

    // Listen for checkbox changes in dropdowns
    document.querySelectorAll('.dropdown').forEach(function(dropdown) {
        dropdown.addEventListener('change', function(e) {
            if (e.target.type === 'checkbox') {
                updateDropdownText(dropdown);
            }
        });
    });

    // Listen for changes on date inputs
    document.querySelectorAll('#start_date, #end_date').forEach(function(input) {
        input.addEventListener('change', function() {
            var filterName = this.id;
            var isActive = this.value.trim() !== '';
            updateFilterIndicator(filterName, isActive);
        });
    });

    // Listen for changes on in_game_network checkbox
    var inGameCheckbox = document.getElementById('in-game-network');
    if (inGameCheckbox) {
        inGameCheckbox.addEventListener('change', function() {
            updateFilterIndicator('in_game_network', this.checked);
        });
    }

    // Listen for changes on the Stay In the Game! Level select
    var gameLevelSelect = document.getElementById('game-level');
    if (gameLevelSelect) {
        gameLevelSelect.addEventListener('change', function() {
            updateFilterIndicator('game_level', this.value !== '');
        });
    }
});
